import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteProductApiV1ProductsOrgIdProductsProductIdDelete } from '@/common/api/client/sdk.gen'
import { useCurrentOrg } from '@/app/entities/org/model'

const deleteProduct = async (org_id: string, product_id: string) => {
    await deleteProductApiV1ProductsOrgIdProductsProductIdDelete({
        path: { org_id, product_id },
    })
}

export const useDeleteProduct = () => {
    const queryClient = useQueryClient()
    const { data: currentOrg } = useCurrentOrg()

    return useMutation({
        mutationFn: (product_id: string) => deleteProduct(currentOrg?.id ?? '', product_id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['products-infinite'] })
        },
    })
}
